import { Button } from "@/components/ui/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

type PaginationProps = {
  page: number;
  size: number;
  totalItems: number;
  onChange: (pagination: { page: number; size: number }) => void;
  pageSizeOptions?: number[];
};

export function Pagination({
  page,
  size,
  totalItems,
  onChange,
  pageSizeOptions = [10, 20, 50, 100],
}: PaginationProps) {
  const totalPages = Math.ceil(totalItems / size);

  const start = totalItems === 0 ? 0 : (page - 1) * size + 1;
  const end = Math.min(page * size, totalItems);

  if (totalItems === 0 && page === 1) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-t pt-4">
      <div className="text-muted-foreground text-sm">
        {totalItems === 0 ? (
          "Aucun résultat"
        ) : (
          <>
            {start}–{end} sur {totalItems}
          </>
        )}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-muted-foreground text-sm">Par page</span>
        <select
          className="border-input bg-background h-9 rounded-md border px-2 text-sm"
          value={size}
          onChange={(e) => onChange({ page: 1, size: Number(e.target.value) })}
        >
          {pageSizeOptions.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <div className="flex gap-1">
          <Button
            variant="outline"
            size="icon"
            disabled={page <= 1}
            onClick={() => onChange({ page: page - 1, size })}
            aria-label="Page précédente"
          >
            <ChevronLeftIcon className="size-4" />
          </Button>

          <Button
            variant="outline"
            size="icon"
            disabled={page >= totalPages}
            onClick={() => onChange({ page: page + 1, size })}
            aria-label="Page suivante"
          >
            <ChevronRightIcon className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
